// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-searchbar {
  text-align: center;
  width: 100%;
  padding: 10px;
  z-index: 400;
}
wm-searchbar .wm-searchbar-textcontainer {
  border-radius: 30px;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  --border-style: none;
}
wm-searchbar .wm-searchbar-textcontainer .wm-searchbar-rightbtn {
  border-left: 1px solid var(--wm-color-grey);
  padding: 7px 2px 7px 11px;
}
wm-searchbar .wm-searchbar-textcontainer form {
  width: 100%;
}
wm-searchbar .wm-searchbar-categoryslider {
  padding: 25px 10px;
  position: absolute;
  top: 40px;
  z-index: 400;
}
wm-searchbar .wm-searchbar-categoryslider .wm-searchbar-categorybtn {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  background: var(--wm-color-light);
  color: var(--wm-color-dark);
  padding: 8px 15px;
  border-radius: 43px;
  font-size: var(--wm-font-sm);
}
wm-searchbar .wm-searchbar-categoryslider .wm-searchbar-categorybtn.wm-searchbar-categorybtn-selected {
  background: var(--wm-color-secondary);
  color: var(--wm-color-light);
}
wm-searchbar .wm-searchbar-categoryslider .wm-searchbar-categorybtn .wm-searchbar-categorylabel {
  padding: 0 5px;
  font-size: var(--wm-font-xsm);
}
wm-searchbar .wm-searchbar-results-backpanel {
  position: absolute;
  width: 100%;
  height: 100vh;
  top: -40px;
  left: 0;
  background-color: var(--wm-color-light);
  z-index: 300;
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container {
  position: relative;
  width: 100%;
  height: 100vh;
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results {
  position: absolute;
  top: 150px;
  bottom: 57px;
  width: 100%;
  height: auto;
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results .wm-searchbar-results-section {
  text-align: left;
  padding: 15px 0;
  border-bottom: 1px solid var(--wm-color-darkgrey);
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results .wm-searchbar-results-section .wm-searchbar-results-section-nodata {
  padding: 15px;
  font-size: var(--wm-font-sm);
  color: var(--wm-color-darkgrey);
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results .wm-searchbar-results-section .wm-searchbar-results-section-name {
  font-size: var(--wm-font-sm);
  color: var(--wm-color-darkgrey);
  text-transform: uppercase;
  padding: 15px;
  display: block;
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results .wm-searchbar-results-section .wm-searchbar-results-section-resultname {
  padding: 5px;
  color: var(--wm-color-dark);
  font-size: var(--wm-font-sm);
  display: block;
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results .wm-searchbar-results-section .wm-searchbar-results-section-resultsubtitle {
  padding: 0px 5px;
  color: var(--wm-color-darkgrey);
  font-size: var(--wm-font-xsm);
  display: block;
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results .wm-searchbar-results-section .wm-searchbar-results-section-resultimage {
  width: 30px;
  height: 30px;
}
wm-searchbar .wm-searchbar-results-backpanel .wm-searchbar-results-container .wm-searchbar-results .wm-searchbar-results-section .wm-searchbar-results-section-resultimage::part(image) {
  object-fit: cover;
  border-radius: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/search-bar/search-bar.component.scss","webpack://./src/app/shared/wm-core/projects/wm-core/src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EAeA,YAAA;AAdF;AACE;EACE,mBAAA;ECNF,2CAAA;EDQE,oBAAA;AACJ;AACI;EACE,2CAAA;EACA,yBAAA;AACN;AACI;EACE,WAAA;AACN;AAIE;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EAkBA,YAAA;AAnBJ;AAGI;ECzBF,2CAAA;ED2BI,iCAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;AADN;AAEM;EACE,qCAAA;EACA,4BAAA;AAAR;AAEM;EACE,cAAA;EACA,6BAAA;AAAR;AAME;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,OAAA;EAEA,uCAAA;EAEA,YAAA;AANJ;AAOI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AALN;AAMM;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAJR;AAKQ;EACE,gBAAA;EACA,eAAA;EACA,iDAAA;AAHV;AAKU;EACE,aAAA;EACA,4BAAA;EACA,+BAAA;AAHZ;AAMU;EACE,4BAAA;EACA,+BAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;AAJZ;AAOU;EACE,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;AALZ;AAQU;EACE,gBAAA;EACA,+BAAA;EACA,6BAAA;EACA,cAAA;AANZ;AASU;EACE,WAAA;EACA,YAAA;AAPZ;AAQY;EACE,iBAAA;EACA,mBAAA;AANd","sourcesContent":["@import '../theme/mixins.scss';\nwm-searchbar {\n  text-align: center;\n  width: 100%;\n  padding: 10px;\n\n  .wm-searchbar-textcontainer {\n    border-radius: 30px;\n    @include box-shadow-light;\n    --border-style: none;\n\n    .wm-searchbar-rightbtn {\n      border-left: 1px solid var(--wm-color-grey);\n      padding: 7px 2px 7px 11px;\n    }\n    form {\n      width: 100%;\n    }\n  }\n  z-index: 400;\n\n  .wm-searchbar-categoryslider {\n    padding: 25px 10px;\n    position: absolute;\n    top: 40px;\n\n    .wm-searchbar-categorybtn {\n      @include box-shadow-light;\n      background: var(--wm-color-light);\n      color: var(--wm-color-dark);\n      padding: 8px 15px;\n      border-radius: 43px;\n      font-size: var(--wm-font-sm);\n      &.wm-searchbar-categorybtn-selected {\n        background: var(--wm-color-secondary);\n        color: var(--wm-color-light);\n      }\n      .wm-searchbar-categorylabel {\n        padding: 0 5px;\n        font-size: var(--wm-font-xsm);\n      }\n    }\n    z-index: 400;\n  }\n\n  .wm-searchbar-results-backpanel {\n    position: absolute;\n    width: 100%;\n    height: 100vh;\n    top: -40px;\n    left: 0;\n\n    background-color: var(--wm-color-light);\n\n    z-index: 300;\n    .wm-searchbar-results-container {\n      position: relative;\n      width: 100%;\n      height: 100vh;\n      .wm-searchbar-results {\n        position: absolute;\n        top: 150px;\n        bottom: 57px;\n        width: 100%;\n        height: auto;\n        .wm-searchbar-results-section {\n          text-align: left;\n          padding: 15px 0;\n          border-bottom: 1px solid var(--wm-color-darkgrey);\n\n          .wm-searchbar-results-section-nodata {\n            padding: 15px;\n            font-size: var(--wm-font-sm);\n            color: var(--wm-color-darkgrey);\n          }\n\n          .wm-searchbar-results-section-name {\n            font-size: var(--wm-font-sm);\n            color: var(--wm-color-darkgrey);\n            text-transform: uppercase;\n            padding: 15px;\n            display: block;\n          }\n\n          .wm-searchbar-results-section-resultname {\n            padding: 5px;\n            color: var(--wm-color-dark);\n            font-size: var(--wm-font-sm);\n            display: block;\n          }\n\n          .wm-searchbar-results-section-resultsubtitle {\n            padding: 0px 5px;\n            color: var(--wm-color-darkgrey);\n            font-size: var(--wm-font-xsm);\n            display: block;\n          }\n\n          .wm-searchbar-results-section-resultimage {\n            width: 30px;\n            height: 30px;\n            &::part(image) {\n              object-fit: cover;\n              border-radius: 15px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","@mixin box-shadow-light {\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n@mixin box-shadow-dark {\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
